module.exports = __webpack_public_path__ + "static/begambleaware-e0189986b99424e541106877400e8552.png";